import type { OrderDTO, UpdateInvoiceOrderDTO } from 'ecosystem'
import { createError, fetchPropsFactory, storefrontApiCall } from '../../utils/fetching'
import { INVOICE_ORDERS_ENDPOINT } from './constants'

export async function updateInvoiceOrder(payload: UpdateInvoiceOrderDTO): Promise<OrderDTO> {
  const props = fetchPropsFactory({
    props: {
      method: 'PUT',
      credentials: 'include',
      body: JSON.stringify(payload)
    }
  })

  // Spec (`FEATURE_B2B_ORDER_PLACEMENT.md` §6) states the response is `OrderDTO`.
  const { data, error } = await storefrontApiCall<OrderDTO>(INVOICE_ORDERS_ENDPOINT, props)

  if (error || !data) {
    throw createError(error || 'Update invoice order error')
  }

  return data
}
